export const FETCH_TRANSLATION_MAP_REQUEST = "FETCH_TRANSLATION_MAP_REQUEST";
export const FETCH_TRANSLATION_MAP_SUCCESS = "FETCH_TRANSLATION_MAP_SUCCESS";
export const FETCH_TRANSLATION_MAP_FAILURE = "FETCH_TRANSLATION_MAP_FAILURE";
export const FETCH_RIGHTS_REQUEST = "FETCH_RIGHTS_REQUEST";
export const FETCH_RIGHTS_SUCCESS = "FETCH_RIGHTS_SUCCESS";
export const FETCH_RIGHTS_FAILURE = "FETCH_RIGHTS_FAILURE";
export const FETCH_SUBRIGHTS_REQUEST = "FETCH_SUBRIGHTS_REQUEST";
export const FETCH_SUBRIGHTS_SUCCESS = "FETCH_SUBRIGHTS_SUCCESS";
export const FETCH_SUBRIGHTS_FAILURE = "FETCH_SUBRIGHTS_FAILURE";
export const FETCH_LEARNMORES_REQUEST = "FETCH_LEARNMORES_REQUEST";
export const FETCH_LEARNMORES_SUCCESS = "FETCH_LEARNMORES_SUCCESS";
export const FETCH_LEARNMORES_FAILURE = "FETCH_LEARNMORES_FAILURE";
export const ADD_OR_EDIT_RIGHTS_REQUEST = "ADD_OR_EDIT_RIGHTS_REQUEST";
export const ADD_OR_EDIT_RIGHTS_SUCCESS = "ADD_OR_EDIT_RIGHTS_SUCCESS";
export const ADD_OR_EDIT_RIGHTS_FAILURE = "ADD_OR_EDIT_RIGHTS_FAILURE";
export const LOGIN_REQUEST = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const SET_SELECTED_RIGHT_CATEGORY = "SET_SELECTED_RIGHT_CATEGORY";
export const SET_SELECTED_SUBRIGHT = "SET_SELECTED_SUBRIGHT";
export const FETCH_ORGS_REQUEST = "FETCH_ORGS_REQUEST";
export const FETCH_ORGS_SUCCESS = "FETCH_ORGS_SUCCESS";
export const FETCH_ORGS_FAILURE = "FETCH_ORGS_FAILURE";
